module.exports = __webpack_public_path__ + "img/15 gustaba.8bd43214.jpg";